export default (set) => [
    'Ich '  + set[0],
    'Du '   + set[1],
    'Er '   + set[2],
    'Sie '  + set[3],
    'Wir '  + set[4],
    'Ihr '  + set[5],
    'Sie '  + set[6],
];


/** WEBPACK FOOTER **
 ** ./generator/randomPhrase/beginningGenerator.js
 **/